"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var material_ui_image_1 = require("material-ui-image");
var carImageStyles_1 = require("./carImageStyles");
var carUnavailable_png_1 = require("../../../../common/assets/images/carUnavailable.png");
var CarImage = function (_a) {
    var imageSrc = _a.imageSrc;
    var styles = carImageStyles_1.default();
    var commonInlineStyles = {
        position: 'relative',
        display: 'block',
        textAlign: 'center',
        height: 'auto',
        objectFit: 'initial',
    };
    var iconInlineStyles = {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        display: 'block',
        textAlign: 'center',
        height: 'auto',
        objectFit: 'initial',
    };
    return (<material_ui_image_1.default src={imageSrc || 'error'} alt="car" animationDuration={2.05} data-test="summary:vehicle:image" color="transparent" imageStyle={commonInlineStyles} iconContainerStyle={iconInlineStyles} style={{ padding: 0, display: 'flex', flexDirection: 'column' }} className={styles.image} errorIcon={<img src={carUnavailable_png_1.default} className={styles.image} data-test={'image:model:unavailable'} alt={'car'}/>}/>);
};
exports.default = CarImage;
